<template>
  <div>
    <div class="el-input">
      <el-input type="text" :value="val.start" style="width:15em" maxlength="24" @input="startChange($event)" />
      -
      <el-input type="text" :value="val.end" style="width:15em" maxlength="24" @input="endChange($event)" />
      <span>合计{{(val.total === '' || 0 > parseInt(val.total)) ? 0 : parseInt(val.total) + 1 }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: {
        start: '',
        end: '',
        total: ''
      }
    }
  },
  mounted () {
    this.val = this.value || { start: '', end: '', total: '' }
    var val = this.val.end
    this.val.total = (val !== '') && (this.val.start !== '') ? this.bigSub(this.dislodgeLetter(val), this.dislodgeLetter(this.val.start)) : ''
  },
  props: ['value'],
  methods: {
    startChange: function (val) {
      this.val = { start: val, end: this.val.end, total: (val !== '') && (this.val.end !== '') ? this.bigSub(this.dislodgeLetter(this.val.end), this.dislodgeLetter(val)) : '' }
      this.$emit('input', this.val)
    },
    endChange: function (val) {
      this.val.end = val
      this.val.total = (val !== '') && (this.val.start !== '') ? this.bigSub(this.dislodgeLetter(val), this.dislodgeLetter(this.val.start)) : ''
      this.$emit('input', this.val)
    },
    bigSub (a, b) {
      var zong = [String(a), String(b)]
      var fen = []
      zong = this.getMax(zong[0], zong[1])
      zong[0] = zong[0].split('')
      zong[1] = zong[1].split('')
      var jialing
      if (!(zong[0].length === zong[1].length)) {
        jialing = new Array(zong[0].length - zong[1].length + 1).join('0')
        zong[1] = jialing.split('').concat(zong[1])
      }
      var next = 0
      for (var i = (zong[0].length - 1); i >= 0; i--) {
        var cha = Number(zong[0][i]) - Number(zong[1][i]) - next
        next = 0
        if (cha < 0) {
          cha = cha + 10
          next = 1
        }
        fen.unshift(cha % 10)
      }
      var result = fen.join('')
      if (result[0] === '0') {
        result = this.shanchuling(result)
      }
      if (result === '') {
        return 0
      }
      if (zong[2] === 'not') {
        return -result
      }
      return result
    },
    dislodgeLetter (str) {
      var result
      var reg = /[a-zA-Z]+/ // [a-zA-Z]表示匹配字母，g表示全局匹配
      result = str.match(reg)
      while (result) { // 判断str.match(reg)是否没有字母了
        str = str.replace(result[0], '') // 替换掉字母  result[0] 是 str.match(reg)匹配到的字母
        result = str.match(reg)
      }
      return str
    },
    getMax (a, b) {
      var result = [a, b]
      if (a.length < b.length) {
        result[0] = b
        result[1] = a
        result[2] = 'not'
        return result
      }
      if (a.length === b.length) {
        for (var i = 0; i < a.length; i++) {
          if (result[0][i] > result[1][i]) {
            result[0] = a
            result[1] = b
            return result
          }
          if (result[0][i] < result[1][i]) {
            result[0] = b
            result[1] = a
            result[2] = 'not'
            return result
          }
          if (i === a.length - 1) {
            return result
          }
        }
      }
      if (a.length > b.length) {
        return result
      }
    },
    shanchuling (result) {
      if (result === '0') {
        result = 0
        return result
      }
      result = result.split('')
      var hebing = result.length
      for (var j = 0; j < hebing; j++) {
        if (result[0] === '0') {
          result.splice(0, 1)
        } else {
          break
        }
      }
      return result.join('')
    }
  },
  watch: {
    value: function (val, oldVal) {
      // console.log(JSON.stringify(val) + JSON.stringify(this.val))
      this.val = val || { start: '', end: '', total: '' }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/RangeInput.vue